import Vue from 'vue'
import Router from 'vue-router'
import store from '../../store'
// import moment from 'moment'
import { refreshUserInfo } from './service'

const Mobile = () => import(/* webpackChunkName: 'mobile' */ './Mobile.vue')
const MNotFound = () => import(/* webpackChunkName: 'mobile' */ './NotFound.vue')
const MNotOpen = () => import(/* webpackChunkName: 'mobile' */ './NotOpen.vue')
const MSpecialList = () => import(/* webpackChunkName: 'mobile' */ './Special/SpecialList.vue')
const MSpecialDetail = () => import(/* webpackChunkName: 'mobile' */ './Special/SpecialDetail.vue')
const MSpecialNewsList = () => import(/* webpackChunkName: 'mobile' */ './Special/SpecialNewsList.vue')
const MPreviewSpecialDetail = () => import(/* webpackChunkName: 'mobile' */ './Special/SpecialDetail')
const MBriefReport = () => import(/* webpackChunkName: 'mobile' */ './BriefReport/BriefReport')
const MPreviewBriefReport = () => import(/* webpackChunkName: 'mobile' */ './BriefReport/BriefReport')
const MPolicyDetail = () => import(/* webpackChunkName: 'mobile' */ './Policy/PolicyDetail')

// const MShareTimeLine = () => import(/* webpackChunkName: 'mobile' */ './Special/ShareTimeLine')
// const MShareMap = () => import(/* webpackChunkName: 'mobile' */ './Special/ShareMap')
// const MShareTable = () => import(/* webpackChunkName: 'mobile' */ './Special/ShareTable')
// const MShareScatter = () => import(/* webpackChunkName: 'mobile' */ './Special/ShareScatter')

const MShareTimeLine = () => import(/* webpackChunkName: 'mobile' */ './Special/ShareTimeLineWx')
const MShareMap = () => import(/* webpackChunkName: 'mobile' */ './Special/ShareMapWx')
const MShareTable = () => import(/* webpackChunkName: 'mobile' */ './Special/ShareTableWx')
const MShareScatter = () => import(/* webpackChunkName: 'mobile' */ './Special/ShareScatterWx')

const MShareTimeLineWx = () => import(/* webpackChunkName: 'mobile' */ './Special/ShareTimeLineWx')
const MShareMapWx = () => import(/* webpackChunkName: 'mobile' */ './Special/ShareMapWx')
const MShareTableWx = () => import(/* webpackChunkName: 'mobile' */ './Special/ShareTableWx')
const MShareScatterWx = () => import(/* webpackChunkName: 'mobile' */ './Special/ShareScatterWx')

// user&pay
const MCollectInfo = () => import(/* webpackChunkName: 'mobile' */ './Pay/CollectInfo')
const MBuyInfo = () => import(/* webpackChunkName: 'mobile' */ './Pay/BuyInfo')
const MPayStatus = () => import(/* webpackChunkName: 'mobile' */ './Pay/PayStatus')
const MLogin = () => import(/* webpackChunkName: 'mobile' */ './User/Login')
const MLogin2 = () => import(/* webpackChunkName: 'mobile' */ './Login/Login')
const VipExperience = () => import(/* webpackChunkName: 'mobile' */ './Pay/VipExperience')
const MExperienceSuccess = () => import(/* webpackChunkName: 'mobile' */ './Pay/ExperienceSuccess')
// 申请试用
const MApplyTest = () => import(/* webpackChunkName: 'mobile' */ './Apply/ApplyTest')
const MApplySuccess = () => import(/* webpackChunkName: 'mobile' */ './Apply/ApplySuccess')

const MLive = () => import(/* webpackChunkName: 'mobile' */ './Live/Live')

const Contact = () => import(/* webpackChunkName: 'mobile' */ './Form/Contact')
const Santen = () => import(/* webpackChunkName: 'mobile' */ './Exterior/Santen.vue') 
const Newsletter = () => import(/* webpackChunkName: 'mobile' */ './Exterior/Newsletter.vue')
const SearchNewsletter = () => import(/* webpackChunkName: 'pc' */ './Exterior/SearchNewsletter.vue') 
const EnSearchNewsletter = () => import(/* webpackChunkName: 'pc' */ './Exterior/EnSearchNewsletter.vue') 

const Viewer = () => import(/* webpackChunkName: 'mobile' */ './Exterior/viewer.vue')
const NewsDetail = () => import(/* webpackChunkName: 'mobile' */ './News/NewsDetail.vue')
const EnNewsletter = () => import(/* webpackChunkName: 'mobile' */ './Exterior/EnNewsletter.vue')

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: '/mindex',
  routes: [
    {path: '/viewer', name: 'MViewer', meta: {keepAlive: false, pc: false}, component: Viewer},
    {
      path: '/',
      name: 'Mobile',
      component: Mobile,
      meta: { pc: false },
      children: [
        {path: 'newsList', name: 'MNewsList', meta: {keepAlive: false, pc: false, title: '抱歉'}, component: MNotOpen},
        {path: 'newsDetail/:uid', name: 'MNewsDetail', meta: {keepAlive: false, pc: false}, component: NewsDetail},
        {path: 'attentionIndex', name: 'MAttentionIndex', meta: {keepAlive: false, pc: false, title: '抱歉'}, component: MNotOpen},
        {path: 'orgDetail/:uid', name: 'MOrgDetail', meta: {keepAlive: false, pc: false, title: '抱歉'}, component: MNotOpen},
        {path: 'companyDetail/:uid', name: 'MCompanyDetail', meta: {keepAlive: false, pc: false, title: '抱歉'}, component: MNotOpen},
        {path: 'compare', name: 'MCompanyCompare', meta: {keepAlive: false, pc: false, title: '抱歉'}, component: MNotOpen},
        {path: 'peoDetail/:uid', name: 'MPeoDetail', meta: {keepAlive: false, pc: false, title: '抱歉'}, component: MNotOpen},
        {path: 'scientific', name: 'Scientific', meta: {keepAlive: false, pc: false, title: '抱歉'}, component: MNotOpen},
        // {path: 'financing', name: 'MFinancingIndex', meta: {keepAlive: false, pc: false}, component: MNotOpen},
        {path: 'specialList', name: 'MSpecialList', meta: {keepAlive: true, pc: false, title: '专题列表'}, component: MSpecialList},
        {path: 'specialDetail/:uid', name: 'MSpecialDetail', meta: {keepAlive: false, pc: false, title: '专题详情'}, component: MSpecialDetail
          // beforeEnter: (to, from, next) => {
          //   if (navigator.userAgent.indexOf('iPhone') > 0 && ('/mindex'+to.path) !== location.pathname) {
          //     location.assign('/mindex'+to.fullPath)
          //   } else {
          //     next()
          //   }
          // }
        },
        {path: 'specialNewsList/:uid', name: 'MSpecialNewsList', meta: {keepAlive: false, pc: false, title: '专题快讯列表'}, component: MSpecialNewsList},
        {path: 'previewSpecialDetail', name: 'MPreviewSpecialDetail', meta: {keepAlive: false, pc: false, title: '专题详情预览'}, component: MPreviewSpecialDetail},
        {path: 'briefReport/:uid', name: 'MBriefReport', meta: {keepAlive: false, pc: false, title: '简报详情'}, component: MBriefReport},
        {path: 'santen', name: 'MSanten', meta: {keepAlive: false, pc: false}, component: Santen},
        {path: 'newsletter', name: 'MNewsletter', meta: {keepAlive: false, pc: false}, component: Newsletter},
        {path: 'ennewsletter', name: 'MEnNewsletter', meta: {keepAlive: false, pc: false}, component: EnNewsletter},
        {path: 'searchNewsletter', name: 'MSearchNewsletter', meta: {keepAlive: false, pc: false}, component: SearchNewsletter},
        {path: 'ensearchNewsletter', name: 'MEnSearchNewsletter', meta: {keepAlive: false, pc: false}, component: EnSearchNewsletter},
        {path: 'previewBriefReport/:uid', name: 'MPreviewBriefReport', meta: {keepAlive: false, pc: false, title: '简报详情预览'}, component: MPreviewBriefReport},
        {path: 'policyDetail/:uid', name: 'MPolicyDetail', meta: {keepAlive: false, pc: false, title: '政策详情'}, component: MPolicyDetail},
        {path: 'collectInfo', name: 'MCollectInfo', meta: {keepAlive: false, pc: false, title: '用户完善信息'}, component: MCollectInfo},
        {path: 'buyInfo/:order_uid/:type', name: 'MBuyInfo', meta: {keepAlive: false, pc: false, title: '确认购买'}, component: MBuyInfo},
        {path: 'vipExperience', name: 'VipExperience', meta: {keepAlive: false, pc: false, title: '赠送VIP'}, component: VipExperience},
        {path: 'experienceSuccess', name: 'MExperienceSuccess', meta: {keepAlive: false, pc: false, title: '赠送VIP'}, component: MExperienceSuccess},
        {path: 'login1', name: 'MLogin', meta: {keepAlive: false, pc: false, title: '登录'}, component: MLogin},
        {path: 'login', name: 'MLogin2', meta: {keepAlive: false, pc: false, title: '登录'}, component: MLogin2},
        {path: 'ok', name: 'MPayStatus', meta: {keepAlive: false, pc: false, title: '购买状态'}, component: MPayStatus},

        {path: 'shareTimeLine', name: 'MShareTimeLine', meta: {keepAlive: false, pc: false, title: '分享时间轴'}, component: MShareTimeLine},
        {path: 'shareMap/:map_id', name: 'MShareMap', meta: {keepAlive: false, pc: false, title: '分享专题图谱'}, component: MShareMap},
        {path: 'shareTable', name: 'MShareTable', meta: {keepAlive: false, pc: false, title: '分享专题表格'}, component: MShareTable},
        {path: 'shareScatter', name: 'MShareScatter', meta: {keepAlive: false, pc: false, title: '专题分享'}, component: MShareScatter},

        {path: 'shareTimeLineWx', name: 'MShareTimeLineWx', meta: {keepAlive: false, pc: false, title: '分享时间轴'}, component: MShareTimeLineWx},
        {path: 'shareMapWx/:map_id', name: 'MShareMapWx', meta: {keepAlive: false, pc: false, title: '分享专题图谱'}, component: MShareMapWx},
        {path: 'shareTableWx', name: 'MShareTableWx', meta: {keepAlive: false, pc: false, title: '分享专题表格'}, component: MShareTableWx},
        {path: 'shareScatterWx', name: 'MShareScatterWx', meta: {keepAlive: false, pc: false, title: '专题分享'}, component: MShareScatterWx},
        {path: 'applyTest', name: 'MApplyTest', meta: {keepAlive: false, pc: false, title: '动脉智库3.0试用申请'}, component: MApplyTest},
        {path: 'applySuccess', name: 'MApplySuccess', meta: {keepAlive: false, pc: false, title: '动脉智库3.0试用申请'}, component: MApplySuccess},
        {path: 'live', name: 'MLive', meta: {keepAlive: false, pc: false, title: '直播频道-动脉网'}, component: MLive},
        
        {path: 'contact', name: 'contact', meta: {keepAlive: false, pc: false, title: '动脉网V+服务收集'}, component: Contact},
        
        {path: 'eventList', name: 'MEventList', meta: {keepAlive: false, pc: false, title: '抱歉'}, component: MNotOpen},
        {path: 'mergersList', name: 'MMergersList', meta: {keepAlive: false, pc: false, title: '抱歉'}, component: MNotOpen},
        {path: 'companyList', name: 'MCompanyList', meta: {keepAlive: false, pc: false, title: '抱歉'}, component: MNotOpen},
        {path: 'orgList', name: 'MOrgList', meta: {keepAlive: false, pc: false, title: '抱歉'}, component: MNotOpen},
        {path: 'hospitalList', name: 'MHospitalList', meta: {keepAlive: false, pc: false, title: '抱歉'}, component: MNotOpen},
        {path: 'hospitalDetail/:uid', name: 'MHospitalDetail', meta: {keepAlive: false, pc: false, title: '抱歉'}, component: MNotOpen},
        {path: 'policyList', name: 'MPolicyList', meta: {keepAlive: false, pc: false, title: '抱歉'}, component: MNotOpen},
        {path: 'searchList', name: 'MSearchList', meta: {keepAlive: false, pc: false, title: '抱歉'}, component: MNotOpen},
        {path: 'reportList', name: 'MReportList', meta: {keepAlive: false, pc: false, title: '抱歉'}, component: MNotOpen},
        {path: 'reportDetail/:uid', name: 'MReportDetail', meta: {keepAlive: false, pc: false, title: '抱歉'}, component: MNotOpen},
        {path: 'userReport', name: 'MUserReport', meta: {keepAlive: false, pc: false, title: '抱歉'}, component: MNotOpen},
        {path: 'orderList', name: 'MOrderList', meta: {keepAlive: false, pc: false, title: '抱歉'}, component: MNotOpen},
        {path: 'openInv', name: 'MOpenInv', meta: {keepAlive: false, pc: false, title: '抱歉'}, component: MNotOpen,},
        {path: 'buyVip', name: 'MBuyVip', meta: {keepAlive: false, pc: false, title: '抱歉'}, component: MNotOpen},
        {path: 'userAccount', name: 'MUserAccount', meta: {keepAlive: false, pc: false, title: '抱歉'}, component: MNotOpen},
        {path: 'userMain', name: 'MUserMain', meta: {keepAlive: false, pc: false, title: '抱歉'}, component: MNotOpen},
        {path: 'index', name: 'MIndex', meta: {keepAlive: false, pc: false, title: '抱歉'}, component: MNotOpen},
        {path: 'log', name: 'MLog', meta: {keepAlive: false, pc: false, title: '抱歉'}, component: MNotOpen},
        {path: 'helpCenter', name: 'MHelpCenter', meta: {keepAlive: false, pc: false, title: '抱歉'}, component: MNotOpen},
        {path: 'about', name: 'MAbout', meta: {keepAlive: false, pc: false, title: '抱歉'}, component: MNotOpen},
        {path: 'workBench', name: 'MWorkBench', meta: {keepAlive: false, pc: false, title: '抱歉'}, component: MNotOpen},
        {path: 'feedList', name: 'MFeedList', meta: {keepAlive: false, pc: false, title: '抱歉'}, component: MNotOpen},
        {path: 'notOpen', name: 'MNotOpen', meta: {keepAlive: false, pc: false, title: '抱歉'}, component: MNotOpen},
       
        {path: '*', name: 'MNotFound', meta: {keepAlive: false, pc: false, title: '抱歉'}, component: MNotFound},
      ]
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition &&  to.meta.keepAlive) {
      return savedPosition
    } else {
      if (from.name != 'MSpecialDetail') {
        return { x: 0, y: 0 }
      }
    }
  }
})

router.beforeEach(async (to, from, next) => {
  // let rep_string = window.location.href
  // let rep = /((<[^>]*)on[a-zA-Z]+\s*=([^>]*>)|(select\b|delete\b|update\b|create\b|insert\b|dump|declare)|(<(\"[^\"]*\"|\'[^\']*\'|[^\'\">])*>)|(window\.|document\.)|(%22|%27|\'|;)|(script|i?frame|style|html|body|title|link|meta|object))/i
  // if(rep.test(rep_string)) {
  //   console.log('过滤非法字符串域名')
  //   window.location.href = window.location.protocol + '//' + window.location.host + '/mindex/specialList'
  // }
  store.commit('updateHtmlTitle', '')
  if (store.state.is_pc) {
    try {
      window.location.href = window.location.protocol + '//' + window.location.host + to.fullPath
    } catch (e) {
      window.location.href = window.location.protocol + '//' + window.location.host
    }
  } else {
    if (!store.state.user_key) {
      if (localStorage.user_key && (localStorage.timestamp_right - localStorage.timestamp_left) < 1296000) {
        store.commit('updateUserKey', localStorage.user_key)
        let user_info = await refreshUserInfo({user_key: localStorage.user_key})
        if (user_info.status == 'success') {
          localStorage.user = JSON.stringify(user_info.res[0])
          store.commit('updateUser', user_info.res[0])
        }
      } else {
        // localStorage.clear()
        window.localStorage.removeItem('timestamp_left')
        window.localStorage.removeItem('timestamp_right')
        window.localStorage.removeItem('user')
        window.localStorage.removeItem('user_key')
      }
    }
    if (navigator.userAgent.indexOf('iPhone') > 0 && ('/mindex'+to.path) !== location.pathname) {
      location.assign('/mindex'+unescape(to.fullPath))
    } else {
      next()
    }
    // next()
  }
})

export default router
